import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

export const AllPermmission = createAsyncThunk(
  "common/masters/all-permission",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPermmission);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllCountry = createAsyncThunk(
  "common/masters/all-country",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCountry}?name=${filter}`);

      return await Select2Data(res.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllRoomTypes = createAsyncThunk(
  "common/masters/all-roomTypes",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.roomType}?name=${filter}`);

      return await Select2Data(res.data.data, "room_type_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// State - Get All (for a specific country)
export const AllState = createAsyncThunk(
  "common/masters/all-state/:id",
  async ({ countryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllState}/${countryId}?name=${name}`
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Get All (for a specific state)
export const AllCity = createAsyncThunk(
  "common/masters/all-city/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCity}/${stateId}?name=${name}`);
      return await Select2Data(res.data.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Pincode - Get All (for a specific city)
export const AllPincode = createAsyncThunk(
  "common/masters/all-pincode/:id",
  async ({ cityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincode}/${cityId}?name=${name}`
      );
      return await Select2Data(res.data.data, "pincode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllArea = createAsyncThunk(
  "common/masters/all-area/:id",
  async ({ pincodeId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllArea}/${pincodeId}?name=${name}`
      );
      return await Select2Data(res.data.data, "area_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Get All
export const AllCategory = createAsyncThunk(
  "common/productmanage/all-category",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCategory);

      return await Select2Data(res.data, "category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllSingleCategory = createAsyncThunk(
  "common/productmanage/single-category",
  async (categoryId, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCategory}/${categoryId}`);

      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Get All
export const AllPartners = createAsyncThunk(
  "common/productmanage/all-partners",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPartners);

      return await Select2Data(res.data, "partners_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// State - Get All (for a specific country)
export const AllSubCategory = createAsyncThunk(
  "common/productmanage/all-subcategory/:id",
  async (categoryId, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSubCategory}/${categoryId}`);

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data, "subcategory_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Get All (for a specific state)
export const GetAllChildCategory = createAsyncThunk(
  "common/masters/all-child-category/:id",
  async (stateId, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllChildCategory}/${stateId}`);
      return await Select2Data(res.data, "childcategory_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Get All
export const AllWhyChooseUs = createAsyncThunk(
  "common/masters/all-whychooseus",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllWhyChooseUs);

      return await Select2Data(res.data, "whychooseus_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Get All
export const AllIndustry = createAsyncThunk(
  "common/masters/all-industry",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllIndustry);

      return await Select2Data(res.data, "industry_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllDepartment = createAsyncThunk(
  "common/masters/all-department",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllDepartment}?name=${filter}`);

      return await Select2Data(res.data.data, "department_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllCompanySize = createAsyncThunk(
  "common/masters/all-companysize",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCompanySize}?name=${filter}`);

      return await Select2Data(res.data.data, "companysize_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Category - Get All
export const AllNeeds = createAsyncThunk(
  "common/productmanage/all-needs",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllNeeds);

      return await Select2Data(res.data, "needs_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllFaq = createAsyncThunk(
  "common/masters/all-faqs",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllFaq}?name=${filter}`);

      return await Select2Data(res.data.data, "faqs_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// SubFaq - Get All (for a specific faq)
export const AllSubFaq = createAsyncThunk(
  "common/masters/all-subfaq/:id",
  async ({ faqsId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSubFaq}/${faqsId}?name=${name}`);

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "subfaq_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllMeterial = createAsyncThunk(
  "common/masters/all-meterial",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllMeterial}?name=${filter}`);

      return await Select2Data(res.data, "material_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllQuantity = createAsyncThunk(
  "common/masters/all-quantity",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllQuantity}?name=${filter}`);

      return await Select2Data(res.data, "quantity_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllLamination = createAsyncThunk(
  "common/masters/all-lamination",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllLamination}?name=${filter}`);

      return await Select2Data(res.data, "lamination_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllEnvelope = createAsyncThunk(
  "common/masters/all-envelope",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllEnvelope}?name=${filter}`);

      return await Select2Data(res.data, "envelop_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllOriantation = createAsyncThunk(
  "common/masters/all-orintation",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllOrientation}?name=${filter}`);

      return await Select2Data(res.data, "orintation_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllPrintLocation = createAsyncThunk(
  "common/masters/all-print-location",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllPrintLocation}?name=${filter}`);

      return await Select2Data(res.data, "print_location_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllShapes = createAsyncThunk(
  "common/masters/all-shapes",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllShapes}?name=${filter}`);

      return await Select2Data(res.data, "shape_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllSocialMedia = createAsyncThunk(
  "common/productmanage/all-socialmedia",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllSocialMedia);

      return await Select2Data(res.data, "socialmedia_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Blog_Category - Get All
export const AllBlog_Category = createAsyncThunk(
  "common/masters/all-blogcategory",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllBlog_Category}?name=${filter}`);

      return await Select2Data(res.data.data, "blog_category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Blog - Get All (for a specific country)
export const AllBlog = createAsyncThunk(
  "common/masters/all-blogs/:id",
  async ({ blogcategoryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllBlog}/${blogcategoryId}?name=${name}`
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "blogs_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllSize = createAsyncThunk(
  "common/masters/all-size",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSize}?name=${filter}`);

      return await Select2Data(res.data, "size_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllDownloadType = createAsyncThunk(
  "common/masters/all-download-type",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllDownloadType}?name=${filter}`);

      return await Select2Data(res.data, "size_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllRoles = createAsyncThunk(
  "common/masters/all-role",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllRoles}?name=${filter}`);

      return await Select2Data(res.data, "role_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllOrderStatus = createAsyncThunk(
  "common/masters/all-order-status",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllOrderStatus);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllUser = createAsyncThunk(
  "common/masters/all-user",
  async ({ role_id }, { rejectWithValue }) => {
    try {

      const res = await GET(`${APIS.Commons.AllTeam}/${role_id}`);
      return await Select2Data(res.data, "designer_id");
      // return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllProduct = createAsyncThunk(
  "common/masters/all-product",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllProduct);
      return await Select2Data(res.data, "product_id");
      // return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllPropertyTypes = createAsyncThunk(
  "common/masters/all-propertyTypes",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPropertyType);
      return await Select2Data(res.data, "property_type_id");
      // return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllPropertyStatus = createAsyncThunk(
  "common/masters/all-propertyStatus",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPropertyStatus);
      return await Select2Data(res.data, "property_status_id");
      // return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllProperty = createAsyncThunk(
  "common/masters/all-property",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllProperty);
      if (res?.data?.success) {
        return res.data
      }
      return await Select2Data(res.data, "property_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllRoom = createAsyncThunk(
  "common/masters/all-room",
  async ({ id }, { rejectWithValue }) => {

    try {
      const res = await GET(`${APIS.Commons.AllRoom}/${id}`);
      if (res?.data?.success) {
        return res.data
      }
      return await Select2Data(res.data, "room_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllSubscriptionHistory = createAsyncThunk(
  "common/masters/AllPropertyHistory",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSubscriptionHistory}?name=${filter?.name || ""}&email=${filter?.email || ""}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`);
      if (res?.data?.success) {
        return res.data
      }
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const PaymentHistory = createAsyncThunk(
  "common/masters/PaymentHistory",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.paymentHistory}?name=${filter?.name || ""}&email=${filter?.email || ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}&owner_id=${filter?.owner_id || ""}&room_id=${filter?.room_id || ""}`);
      if (res?.data?.success) {
        return res.data
      }
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const AllOwners = createAsyncThunk(
  "common/masters/AllOwners",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.UserManagement.Owner}?name=${filter?.name || ""}&email=${filter?.email || ""}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}&owner_id=${filter?.owner_id || ""}&room_id=${filter?.room_id || ""}`);
      if (res?.success) {
        return await Select2Data(res?.data?.data, "owner_id");
      }
      return res.data

    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllBenefits = createAsyncThunk(
  "common/masters/AllBenefits",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllBenefits}`);
      if (res?.success) {
        return await res?.data?.data;
      }
      return res.data

    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllMessageCombinations = createAsyncThunk(
  "common/masters/AllMessageCombinations",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllMessageCombinations}`);
      if (res?.success) {
        return await Select2Data(res?.data, "combination_id");
      }
      return res.data

    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllTemplates = createAsyncThunk(
  "common/masters/AllTemplates",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTemplates}`);
      if (res?.success) {
        return await Select2Data(res?.data, "template_id");
      }
      return res.data

    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const Slice = createSlice({
  name: "common",
  initialState: {
    payment_history: [],
    all_owner: [],
    all_property_type: [],
    all_property_status: [],
    all_property: [],
    all_sub_history: [],
    all_room: [],
    all_country: [],
    all_state: [],
    all_city: [],
    all_pincode: [],
    all_area: [],
    all_roomType: [],
    all_category: [],
    single_category: {},
    all_subcategory: [],
    all_childcategory: [],
    all_partners: [],
    all_whychooseus: [],
    all_industry: [],
    all_department: [],
    all_companysize: [],
    all_needs: [],
    all_faqs: [],
    all_subfaq: [],
    all_meterial: [],
    all_quantity: [],
    all_lamination: [],
    all_print_location: [],
    all_envelope: [],
    all_orientation: [],
    all_shapes: [],
    all_socialmedia: [],
    all_blogcategory: [],
    all_blogs: [],
    all_size: [],
    all_download_type: [],
    all_orderstatus: [],
    all_permission: {},
    all_roles: [],

    all_team: [],
    all_product: [],
    all_benefits: [],

    all_message_combination: [],
    all_templates: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllMessageCombinations.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllMessageCombinations.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_message_combination = action.payload || [];
      })
      .addCase(AllMessageCombinations.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTemplates.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTemplates.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_templates = action.payload || [];
      })
      .addCase(AllTemplates.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBenefits.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBenefits.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_benefits = action.payload || [];
      })
      .addCase(AllBenefits.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllOwners.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllOwners.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_owner = action.payload || [];
      })
      .addCase(AllOwners.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(PaymentHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(PaymentHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.payment_history = action.payload || [];
      })
      .addCase(PaymentHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSubscriptionHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSubscriptionHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_sub_history = action.payload || [];
      })
      .addCase(AllSubscriptionHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllRoom.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllRoom.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_room = action.payload || [];
      })
      .addCase(AllRoom.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_property = action.payload || [];
      })
      .addCase(AllProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })


      .addCase(AllPropertyTypes.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPropertyTypes.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_property_type = action.payload || [];
      })
      .addCase(AllPropertyTypes.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPropertyStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPropertyStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_property_status = action.payload || [];
      })
      .addCase(AllPropertyStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })


      .addCase(AllRoomTypes.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllRoomTypes.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_roomType = action.payload || [];
      })
      .addCase(AllRoomTypes.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(AllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincode = action.payload || [];
      })
      .addCase(AllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })


      .addCase(AllArea.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllArea.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_area = action.payload || [];
      })
      .addCase(AllArea.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_category = action.payload || [];
      })
      .addCase(AllCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSingleCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSingleCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.single_category = action.payload || [];
      })
      .addCase(AllSingleCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllSubCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSubCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_subcategory = action.payload || [];
      })
      .addCase(AllSubCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(GetAllChildCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllChildCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_childcategory = action.payload || [];
      })
      .addCase(GetAllChildCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllPartners.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPartners.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_partners = action.payload || [];
      })
      .addCase(AllPartners.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllWhyChooseUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllWhyChooseUs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_whychooseus = action.payload || [];
      })
      .addCase(AllWhyChooseUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllIndustry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllIndustry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_industry = action.payload || [];
      })
      .addCase(AllIndustry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllDepartment.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllDepartment.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_department = action.payload || [];
      })
      .addCase(AllDepartment.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCompanySize.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCompanySize.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_companysize = action.payload || [];
      })
      .addCase(AllCompanySize.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetCategory
      .addCase(AllNeeds.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllNeeds.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_needs = action.payload || [];
      })
      .addCase(AllNeeds.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllFaq.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllFaq.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_faqs = action.payload || [];
      })
      .addCase(AllFaq.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllSubFaq.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSubFaq.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_subfaq = action.payload || [];
      })
      .addCase(AllSubFaq.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllMeterial.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllMeterial.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_meterial = action.payload || [];
      })
      .addCase(AllMeterial.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllQuantity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllQuantity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_quantity = action.payload || [];
      })
      .addCase(AllQuantity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllOriantation.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllOriantation.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_orientation = action.payload || [];
      })
      .addCase(AllOriantation.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllPrintLocation.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPrintLocation.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_print_location = action.payload || [];
      })
      .addCase(AllPrintLocation.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllLamination.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllLamination.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_lamination = action.payload || [];
      })
      .addCase(AllLamination.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllEnvelope.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllEnvelope.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_envelope = action.payload || [];
      })
      .addCase(AllEnvelope.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllShapes.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllShapes.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_shapes = action.payload || [];
      })
      .addCase(AllShapes.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllSocialMedia.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSocialMedia.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_socialmedia = action.payload || [];
      })
      .addCase(AllSocialMedia.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllBlog_Category.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBlog_Category.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_blogcategory = action.payload || [];
      })
      .addCase(AllBlog_Category.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllBlog.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBlog.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_blogs = action.payload || [];
      })
      .addCase(AllBlog.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSize.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSize.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_size = action.payload || [];
      })
      .addCase(AllSize.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllDownloadType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllDownloadType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_download_type = action.payload || [];
      })
      .addCase(AllDownloadType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPermmission.pending, (state) => {
        console.log("action.payload pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPermmission.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_permission = action.payload || {};
      })
      .addCase(AllPermmission.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      })

      .addCase(AllRoles.pending, (state) => {
        console.log("action.payload pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllRoles.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        state.all_roles = action.payload || [];
      })
      .addCase(AllRoles.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;

        state.error = action.payload;
      })

      .addCase(AllOrderStatus.pending, (state) => {
        console.log("action.payload pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllOrderStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;


        state.all_orderstatus = action.payload || [];

      })
      .addCase(AllOrderStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        console.log("action.payload reject");
        state.error = action.payload;
      })

      .addCase(AllUser.pending, (state) => {
        console.log("action.payload pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllUser.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;


        state.all_team = action.payload || [];

      })
      .addCase(AllUser.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        console.log("action.payload reject");
        state.error = action.payload;
      })

      .addCase(AllProduct.pending, (state) => {
        console.log("action.payload pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProduct.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;


        state.all_product = action.payload || [];

      })
      .addCase(AllProduct.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        console.log("action.payload reject");
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
